// extracted by mini-css-extract-plugin
export var root = "SectionParagraph-module--root--3QQKC";